<script>
export default {
  name: 'BestOdds',
  props: {
    display: {
      type: String,
      default: 'logo',
    },
    selectionId: {
      type: [Number, String],
      required: true,
    },
    odds: {
      type: Object,
      required: true,
    },
  },
  computed: {
    bookie: function() {
      return this.odds && this.odds.hasOwnProperty('bookmakerId') ? this.odds.bookmakerId : '';
    },
    domClasses: function() {
      const domClasses = ['best-odds__component'];

      if (this.display === 'movement') {
        domClasses.push('best-odds__movement');
        domClasses.push(`best-odds__movement-${this.movementDirection}`);
      } else {
        domClasses.push('best-odds__bookie');
        domClasses.push(`best-odds__bookie-${this.bookie}`);
      }

      return domClasses;
    },
    movement: function() {
      return this.odds && this.odds.hasOwnProperty('price') ? this.odds.price.movement : 0;
    },
    movementDirection: function() {
      if (this.movement > 0) {
        return 'up';
      }
      if (this.movement < 0) {
        return 'down';
      }
      return 'same';
    },
    price: function() {
      return this.odds && this.odds.hasOwnProperty('price') ? this.odds.price.value : 0;
    },
    priceFormatted: function() {
      return this.price > 0 ? '$' + this.price.toFixed(2) : '';
    },
  },
};
</script>
<template>
  <button v-show="price"
          v-if="display === 'movement'"
          :class="[...domClasses, 'quickbet-odds', 'quickbet-button', 'quickbet-button__bet-price']"
          :data-selection-id="selectionId">
    {{ priceFormatted }}
  </button>
  <div v-else :class="domClasses">
    {{ priceFormatted }}
    <button v-show="price" :data-selection-id="selectionId" class="best-odds__bet quickbet-odds quickbet-button__bet"><slot>Bet</slot></button>
  </div>
</template>
